export const fields = [
    'numberOfSuppliers',
    'numberOfInvoices',
    'totalInvoiceAmount',
    'paymentDue',
    'paymentDueAverage',
    'paymentDueModus',
    'paymentDueMax',
]
